// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart__bde + .timeFrameSelector__c8c {
  margin-top: calc(var(--ring-unit) * 0.5);
}

.timeFrameSelector__c8c + .statisticsCounter__d01 {
  margin-top: calc(var(--ring-unit) * 1.5);
}

.chart__bde + .statisticsCounter__d01 {
  margin-top: calc(var(--ring-unit) * 1.5);
}

.infoStat__e36 + .infoStat__e36 {
  margin-top: calc(var(--ring-unit) * 0.5);
}

.infoStat__e36 + .chart__bde {
  margin-top: calc(var(--ring-unit) * 2);
}

.infoStat__e36 + .statisticsCounter__d01 {
  margin-top: calc(var(--ring-unit) * 2);
}

.timeFrameSelector__c8c .label__ad1 {
  color: var(--ring-secondary-color);
}

.statisticsCounter__d01 {
  display: inline-flex;
  align-items: baseline;
  flex-wrap: nowrap;
  white-space: nowrap;

  width: 100%;
  color: var(--ring-secondary-color);

  .count__fcf {
    font-size: var(--ring-font-size-larger);
    line-height: var(--ring-line-height-taller);
  }

  .label__ad1 {
    overflow: hidden;
    text-overflow: ellipsis;

    font-size: var(--ring-font-size-smaller);
    line-height: var(--ring-line-height-lowest);
  }

  .icon__b6f {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon__b6f + .count__fcf {
    margin-left: calc(var(--ring-unit) * 0.5);
  }

  .count__fcf + .label__ad1 {
    margin-left: calc(var(--ring-unit) * 1.5);
  }
}

.infoStat__e36 {
  width: 100%;

  display: flex;
  align-items: flex-start;
  white-space: nowrap;

  font-size: var(--ring-font-size-larger);
  line-height: var(--ring-line-height-taller);

  .statName__a2a {
    overflow: hidden;
    text-overflow: ellipsis;

    color: var(--ring-secondary-color);
  }

  .statValue__fcf {
    white-space: initial;
  }

  &.wide__d90 {
    justify-content: space-between;
  }

  &.narrow__bf4 {
    .statValue__fcf {
      margin-left: calc(var(--ring-unit) * 1.5);
    }
  }

  &.twoColumns__f60 {
    .statName__a2a,
    .statValue__fcf {
      flex: 1 0 50%;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/common/widgets/statistics-widget/statistics-widget.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;;EAEnB,WAAW;EACX,kCAAkC;;EAElC;IACE,uCAAuC;IACvC,2CAA2C;EAC7C;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;;IAEvB,wCAAwC;IACxC,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,WAAW;;EAEX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,uCAAuC;EACvC,2CAA2C;;EAE3C;IACE,gBAAgB;IAChB,uBAAuB;;IAEvB,kCAAkC;EACpC;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE;MACE,yCAAyC;IAC3C;EACF;;EAEA;IACE;;MAEE,aAAa;IACf;EACF;AACF","sourcesContent":[".chart + .timeFrameSelector {\n  margin-top: calc(var(--ring-unit) * 0.5);\n}\n\n.timeFrameSelector + .statisticsCounter {\n  margin-top: calc(var(--ring-unit) * 1.5);\n}\n\n.chart + .statisticsCounter {\n  margin-top: calc(var(--ring-unit) * 1.5);\n}\n\n.infoStat + .infoStat {\n  margin-top: calc(var(--ring-unit) * 0.5);\n}\n\n.infoStat + .chart {\n  margin-top: calc(var(--ring-unit) * 2);\n}\n\n.infoStat + .statisticsCounter {\n  margin-top: calc(var(--ring-unit) * 2);\n}\n\n.timeFrameSelector .label {\n  color: var(--ring-secondary-color);\n}\n\n.statisticsCounter {\n  display: inline-flex;\n  align-items: baseline;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n\n  width: 100%;\n  color: var(--ring-secondary-color);\n\n  .count {\n    font-size: var(--ring-font-size-larger);\n    line-height: var(--ring-line-height-taller);\n  }\n\n  .label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    font-size: var(--ring-font-size-smaller);\n    line-height: var(--ring-line-height-lowest);\n  }\n\n  .icon {\n    width: 20px;\n    height: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .icon + .count {\n    margin-left: calc(var(--ring-unit) * 0.5);\n  }\n\n  .count + .label {\n    margin-left: calc(var(--ring-unit) * 1.5);\n  }\n}\n\n.infoStat {\n  width: 100%;\n\n  display: flex;\n  align-items: flex-start;\n  white-space: nowrap;\n\n  font-size: var(--ring-font-size-larger);\n  line-height: var(--ring-line-height-taller);\n\n  .statName {\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    color: var(--ring-secondary-color);\n  }\n\n  .statValue {\n    white-space: initial;\n  }\n\n  &.wide {\n    justify-content: space-between;\n  }\n\n  &.narrow {\n    .statValue {\n      margin-left: calc(var(--ring-unit) * 1.5);\n    }\n  }\n\n  &.twoColumns {\n    .statName,\n    .statValue {\n      flex: 1 0 50%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chart": `chart__bde`,
	"timeFrameSelector": `timeFrameSelector__c8c`,
	"statisticsCounter": `statisticsCounter__d01`,
	"infoStat": `infoStat__e36`,
	"label": `label__ad1`,
	"count": `count__fcf`,
	"icon": `icon__b6f`,
	"statName": `statName__a2a`,
	"statValue": `statValue__fcf`,
	"wide": `wide__d90`,
	"narrow": `narrow__bf4`,
	"twoColumns": `twoColumns__f60`
};
export default ___CSS_LOADER_EXPORT___;
